import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Text } from "src/components";
import Box from "react-raster";
import { theme } from "src/config";

type PasswordStrengthProps = {
  password?: string;
  passwordRepeat?: string;
  onValidate?: (valid: boolean) => void;
};

export const PasswordStrength = ({
  password = "",
  passwordRepeat = "",
  onValidate
}: PasswordStrengthProps): JSX.Element => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const length = password.length >= 6;
    const repeats = passwordRepeat.length >= 6;
    const number = /\d/.test(password);
    const matches = length && repeats && password === passwordRepeat;
    const uppercase = /[A-Z]/.test(password);
    const lowercase = /[a-z]/.test(password);
    const specials = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);
    const valid =
      length && number && matches && uppercase && lowercase && specials;
    onValidate(valid);
  }, [password, passwordRepeat]);

  const length = password.length >= 6;
  const repeats = passwordRepeat.length >= 6;
  const number = /\d/.test(password);
  const matches = length && repeats && password === passwordRepeat;
  const uppercase = /[A-Z]/.test(password);
  const lowercase = /[a-z]/.test(password);
  const specials = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);
  const valid =
    length && number && matches && uppercase && lowercase && specials;

  let password_result = "";
  if (length && repeats && !matches) {
    password_result = t("password_miss_match");
  } else if (length && !valid) {
    password_result = t("password_not_valid");
  }

  return (
    <>
      <Box
        colspan={2}
        gridColumnGap={theme.layout.gutterSmall}
        gridRowGap={theme.layout.gutter}
      >
          <Box cols={1} display="flex" flexDirection="row">
            {length ? <Icon size="medium" iconId="checkmark" color='green' /> : <Icon size="medium" iconId="close" color='red'/>}
            <Text size="small" style={{ textDecoration: length ? "" : "underline" }}>
              {t("password_strength_contains_six_characters")}
            </Text>
          </Box>
            <Box cols={1} display="flex" flexDirection="row" style={{ textDecoration: number ? "" : "underline" }}>
        {number ? <Icon size="medium" iconId="checkmark" color='green' /> : <Icon size="medium" iconId="close" color='red'/>}
            <Text size="small" style={{ textDecoration: length ? "" : "underline" }}>
              {t("password_strength_contains_number")}
              </Text>
            </Box>
          <Box cols={1} display="flex" flexDirection="row">
          {matches ? <Icon size="medium" iconId="checkmark" color='green' /> : <Icon size="medium" iconId="close" color='red' />}
            <Text size="small" style={{ textDecoration: matches ? "" : "underline" }}>
              {t("password_strength_repeats_match")}
            </Text>
          </Box>
          <Box cols={1} display="flex" flexDirection="row">
      {specials ? <Icon size="medium" iconId="checkmark" color='green' /> : <Icon size="medium" iconId="close" color='red' />}
            <Text size="small" style={{ textDecoration: length ? "" : "underline" }}>
              {t("password_strength_contains_specials")}
            </Text>
          </Box>
          <Box cols={1} display="flex" flexDirection="row">
        {lowercase ? <Icon size="medium" iconId="checkmark" color='green'/> : <Icon size="medium" iconId="close" color='red' />}
            <Text size="small" style={{ textDecoration: length ? "" : "underline" }}>
              {t("password_strength_contains_lowercase")}
            </Text>
          </Box>
          <Box cols={1} display="flex" flexDirection="row">
          {uppercase ? <Icon size="medium" iconId="checkmark" color='green'/> : <Icon size="medium" iconId="close" color='red'/>}
            <Text size="small" style={{ textDecoration: length ? "" : "underline" }}>
              {t("password_strength_contains_uppercase")}
            </Text>
          </Box>
      <Text size="small" color="error">{password_result}</Text>
      </Box>
    </>
  );
};

